import { Routes } from '@angular/router';
import { authGuard } from './core/auth/guards/auth.guard';
import { PageLayoutComponent } from './core/layout/page-layout/page-layout.component';

export const routes: Routes = [
  // Public routes (no layout)
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login.component')
      .then(m => m.LoginComponent)
  },

  // Protected routes (wrapped in FullLayoutComponent shell)
  {
    path: '',
    component: PageLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component')
          .then(m => m.DashboardComponent),
      },
      {
        path: 'sync-programs-subjects',
        loadComponent: () => import('./features/sync-programs-subjects/sync-programs-subjects.component')
          .then(m => m.SyncProgramsSubjectsComponent),
      },
      {
        path: 'system-settings',
        loadComponent: () => import('./features/system-settings/system-settings.component')
          .then(m => m.SystemSettingsComponent),
      },
      {
        path: 'users',
        loadComponent: () => import('./features/users/users.component')
          .then(m => m.UsersComponent),
      },
      {
        path: 'exam-manager/exam-list',
        loadComponent: () => import('./features/exam-manager/exam-list/exam-list.component')
          .then(m => m.ExamListComponent),
      },
      {
        path: 'exam-manager/add-exam',
        loadComponent: () => import('./features/exam-manager/add-exam/add-exam.component')
          .then(m => m.AddExamComponent),
      },
      {
        path: 'exam-manager/add-exam/:code',
        loadComponent: () => import('./features/exam-manager/add-exam/add-exam.component')
          .then(m => m.AddExamComponent),
      },
      {
        path: 'exam-manager/add-questions/:examId',
        loadComponent: () => import('./features/exam-manager/add-questions-to-exam/add-questions-to-exam.component')
          .then(m => m.AddQuestionsToExamComponent),
      },
      {
        path: 'exam-manager/addQuestionsCreateExam/:examId',
        loadComponent: () => import('./features/exam-manager/add-questions-create-exam/add-questions-create-exam.component')
          .then(m => m.AddQuestionsCreateExamComponent),
      },
      {
        path: 'exam-manager/edit-exam/:examId',
        loadComponent: () => import('./features/exam-manager/edit-exam/edit-exam.component')
          .then(m => m.EditExamComponent),
      },
      {
        path: 'exam-manager/exam-questions/:examId',
        loadComponent: () => import('./features/exam-manager/exam-questions-preview/exam-questions-preview.component')
          .then(m => m.ExamQuestionsPreviewComponent),
      },
      {
        path: 'exam-manager/assign-exam/:examId',
        loadComponent: () => import('./features/exam-manager/exam-assign/exam-assign.component')
          .then(m => m.ExamAssignComponent),
      },
      {
        path: 'exam-manager/examPapers/:examId',
        loadComponent: () => import('./features/exam-manager/exam-papers/exam-papers.component')
          .then(m => m.ExamPapersComponent),
      },
      {
        path: 'exam-manager/markExam/:examId',
        loadComponent: () => import('./features/exam-manager/mark-exam/mark-exam.component')
          .then(m => m.MarkExamComponent),
      },
      {
        path: 'exam-manager/markExam/:examId/:code',
        loadComponent: () => import('./features/exam-manager/mark-exam/mark-exam.component')
          .then(m => m.MarkExamComponent),
      },
      {
        path: 'exam-manager/examResults/:examId',
        loadComponent: () => import('./features/exam-manager/exam-results/exam-results.component')
          .then(m => m.ExamResultsComponent),
      },
      {
        path: 'exam-manager/examResults/:examId/:code',
        loadComponent: () => import('./features/exam-manager/exam-results/exam-results.component')
          .then(m => m.ExamResultsComponent),
      },
      {
        path: 'exam-manager/violations/:examLinkId',
        loadComponent: () => import('./features/exam-manager/exam-violations/exam-violations.component')
          .then(m => m.ExamViolationsComponent),
      },
      {
        path: 'exam-manager/photos/:examLinkId',
        loadComponent: () => import('./features/exam-manager/exam-photos/exam-photos.component')
          .then(m => m.ExamPhotosComponent),
      },
      {
        path: 'question-manager/questions',
        loadComponent: () => import('./features/question-bank/question-list/question-list.component')
          .then(m => m.QuestionListComponent),
      },
      {
        path: 'question-manager/add-question',
        loadComponent: () => import('./features/question-bank/add-question/add-question.component')
          .then(m => m.AddQuestionComponent),
      },
      {
        path: 'question-manager/add-question/:questionId',
        loadComponent: () => import('./features/question-bank/add-question/add-question.component')
          .then(m => m.AddQuestionComponent),
      },
    ],
  },

  // Cloud Campus portal entry point (no auth guard — session is injected via URL param)
  {
    path: 'css-login/:userString/:view/:code',
    loadComponent: () => import('./features/auth/login/login.component')
      .then(m => m.LoginComponent)
  },

  // Fallback
  { path: '**', redirectTo: '/login' },
];